import { OrdersSalesQueryKeys } from '@enums/react-query-keys';
import { getCarriers } from '@services/my-orders-sales-service';
import { useQuery } from '@tanstack/react-query';

const useGetCarriers = (productId: string) => {
  return useQuery({
    queryKey: [OrdersSalesQueryKeys.GET_SHIPPING_LABEL, productId],
    queryFn: () => getCarriers(productId),
    cacheTime: 0,
  });
};

export default useGetCarriers;
